import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Button from "@elements/button";
import LeftArrow from "@svg/LeftArrow";
import { useRiddlesNavigation, useRiddlesQuestion } from "../RamadanRiddlesContext";

const RamadanRiddlesCorrectAnswer: React.FC = () => {
    const t = useTranslations();
    const { setView } = useRiddlesNavigation();
    const { data: questionData } = useRiddlesQuestion();
    const headerTitle = questionData?.title ?? t("Day of Ramadan");

    return (
        <div className="flex h-full flex-col bg-[#FDDBA6]">
            <div className="relative flex min-h-screen flex-1 flex-col">
                <div className="relative">
                    <Image
                        src="/svgs/ramadan-riddle-misbah-header.svg"
                        alt=""
                        aria-hidden="true"
                        width={419}
                        height={179}
                        sizes="100vw"
                        className="mx-auto h-auto w-[85%]"
                    />
                    <button
                        type="button"
                        onClick={() => setView("progress")}
                        className="absolute left-5 top-4 text-[#38190D]"
                        aria-label={t("Back")}
                    >
                        <LeftArrow />
                    </button>
                </div>

                <div className="px-5 pb-6">
                    <div className="mt-2 text-center">
                        <p className="text-sm font-semibold text-[#38190D]">
                            {t("Today's Riddle")}
                        </p>
                        <h1 className="mt-1 text-2xl font-extrabold uppercase text-[#38190D]">
                            {headerTitle}
                        </h1>
                    </div>

                    <div className="mt-8 flex flex-col items-center text-center text-[#38190D]">
                        <Image
                            src="/svgs/successBear.svg"
                            alt={t("Success")}
                            width={200}
                            height={290}
                            className="h-auto w-[160px]"
                        />
                        <h2 className="mt-5 text-2xl font-extrabold uppercase">{t("Correct!")}</h2>
                        <p className="mt-3 text-base font-medium">
                            {t("You nailed it! Here's today's reward!")}
                        </p>
                    </div>

                    <Button
                        className="mt-7 h-12 w-full rounded-full bg-[#F27D23] font-bold uppercase text-white outline-none border-none"
                        onClick={() => setView("rewards")}
                    >
                        {t("Reveal my reward")}
                    </Button>
                </div>

                <div className="mt-auto pt-6">
                    <Image
                        src="/svgs/ramadan-riddle-cloud-mosque.svg"
                        alt=""
                        aria-hidden="true"
                        width={498}
                        height={313}
                        sizes="100vw"
                        className="h-auto w-full"
                    />
                </div>
            </div>
        </div>
    );
};

export default RamadanRiddlesCorrectAnswer;
